import React, { useState } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleItem } from '../../../Store/PHPSlice/Item';

const TableBody = ({
    id,
    serialNumber,
    itemNm,
    marathiNm,
    size,
    hsn,
    itemImg,
    locId,
    locNm,
    selected,
    handleClick,
}) => {


    const imgUrl = process.env.REACT_APP_IMAGE_URL;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const dispatch = useDispatch();
    // const getDelete = useSelector((state) => state.companyData.deleteComp);
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/ItemEdit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Item?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteSingleItem(id))
                .then(() => {
                    // Reload the page to show updated results
                    toast("Item Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting Item:", error);
                    toast.error("Failed to delete Item");
                });
        }
    };

    const newImg = itemImg.replace(/ /g, '%20');



    // Function to open the modal
    const openModal = (imageUrl) => {
        // const url = `http://localhost:8081/demoApi/${imageUrl}`;
        const url = `${imgUrl}/${imageUrl}`;
        setSelectedImage(url);
        setIsModalOpen(true);
    };

    // Function to close the modal
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedImage(null);
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{serialNumber}</TableCell>


                <TableCell component="th" scope="row" sx={{ p: 1, border: '1px solid #000' }} align='center'>

                    <Typography variant="subtitle2" noWrap>
                        {itemNm}
                    </Typography>

                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{marathiNm}</TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{hsn}</TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{size}</TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{locNm}</TableCell> */}


                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {/* {itemImg} */}
                    {itemImg === 'noImage' ? itemImg :
                        <img
                            // src={`http://localhost:8081/demoApi/${newImg}`}
                            src={`${imgUrl}/${newImg}`}
                            style={{ width: '8vw', height: '10vh', margin: '0.5vw', cursor: 'pointer' }}
                            alt="Item Thumbnail"
                            onClick={() => openModal(newImg)}
                        />
                    }
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className="cursor-pointer" onClick={handleEditClick} />
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
            {isModalOpen && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <span className="modal-close" onClick={closeModal}>X</span>
                        <img src={selectedImage} style={{ maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain' }} alt="Large View" />
                    </div>
                </div>
            )}
        </>
    );
};

export default TableBody;
